import { OnDestroy, OnInit, Component  } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { BsModalRef } from 'ngx-bootstrap';
import { Observable, Subject } from 'rxjs';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { DocumentService } from 'app/shared/services/document.service';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { summaryFileName } from '@angular/compiler/src/aot/util';
import { IDtoRequisitionTracking } from 'app/shared/models/opening/dto-requisition-tracking.model';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-modal-upload-files',
  styleUrls: ['./modal-upload-files.style.scss'],
  templateUrl: './modal-upload-files.template.html'
})

export class ModalUploadFilesComponet implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private formApprover: FormGroup;
  /**Retorno a pantalla padre */
  public onClose: Subject<string>;
  /**Catalogos */
  private catalogApprovers: Observable<IDtoCatalog[]>;
  private approver: string;
  private name: string;
  private folder: string;
  private module: string;
  private jobCandidateId: number;
  private id: number;
  private document: IDtoDocument[] = [];
  private type: string;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private bsModalRef: BsModalRef
    , private customerService: CustomerService
    , private documentService: DocumentService
    , private datePipe: DatePipe
    , private spinner: NgxSpinnerService) {
    this.initializeFormApprover();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.getDocuments();
  }
  private initializeFormApprover() {
    this.formApprover = this.formBuilder.group({
      nombreCorto: ['', Validators.required]
    });
  }
  private submitForm(files: FileList, nombreCorto: string): void {
    if (this.formApprover.valid) {
      this.upload(files, nombreCorto);
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
    }
  }
  private update(): void {
    //this.approver = this.formApprover.value.approver;
    this.onClose.next(this.approver);
    this.bsModalRef.hide();
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private onFileChange(event) {
    event.value = '';

  }

  handleFileInput(files: FileList) {
    if (files.length > 0) {
      const selectedFile = files[0];
      //
      const nombreCortoControl = this.formApprover.get('nombreCorto');
      if (nombreCortoControl) {
        let nombreCorto = nombreCortoControl.value;
        this.submitForm(files, nombreCorto);
      } else {
        console.error('El control "nombreCorto" no existe en el formulario.');
      }
    }
  }
  private getDocuments(): void {
    this.documentService.getDocuments(this.id, this.name).subscribe(res => {
        this.document = res.data as IDtoDocument[];
    })
  }
  private upload(files: FileList, nombreCorto: string): void {
    if (files != undefined) {
        this.spinner.show();
        let document = {} as IDtoDocument;
        const fileName = files.item(0).name;
        let sp = fileName.split('.').pop();
        let fileNameNew = `${this.jobCandidateId}_${this.name}_${nombreCorto}_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
        document.fileName = fileNameNew;
        //this.fileName = fileNameNew;
        document.referenceId = this.id;
        document.folder = this.folder;
        document.module = this.module;
        document.name = this.name;
        document.acceptDuplicate = true;
        const file = files.item(0);
        this.documentService.addDocument(document, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.configGeneral.newToast('Éxito', res.message, 'success');
                this.getDocuments();
                //this.document = res.data as IDtoDocument;
                //this.fileName = this.document.fileName;
                //this.addModuleLog(this.customer.id, 'addRequisitionTracking');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
  }
  private deleteFile(item: IDtoDocument): void {
    if (item.id == undefined) {
      return;
    }
    this.documentService.deleteDocumentByName(item.referenceId, item.name, item.fileName).subscribe((res) => {
      if (res.isCorrect === true) {
        this.configGeneral.newToast('Éxito', 'Documento eliminado correctamente', 'success');
        this.getDocuments();
      }
    });
  }
  private downloadFile(item: IDtoDocument): void {
    this.documentService.downloadFile(item.id).subscribe((res) => {
        if (res.isCorrect === true) {
            const file = res.data as any;
            const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
            saveAs(blob, file.fileDownloadName);
            this.spinner.hide();
        } else {
            this.configGeneral.newToast('Error', res.message, 'error');
            this.spinner.hide();
        }
    },
    (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
    });
}
}
